import styled from 'styled-components';

export const RelatedTopicContainer = styled.section`
  margin-top: 30px;
`;

export const RelatedCardSectionGrid = styled.div`
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;

  @media (max-width: 720px) {
    grid-template-columns: 100%;
  }
`;

export const CardBox = styled.div`
  padding: 10px 8px;
  border: 1px solid rgb(0 0 0 / 10%);
  border-radius: 8px;
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  @media (max-width: 720px) {
    cursor: default;
  }
  cursor: pointer;
  .mother_stage {
    font-size: 12px;
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 70%);
    text-transform: capitalize;
  }
`;

export const TopicImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 8px 0 12px;
`;

export const TopicTitle = styled.h4`
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  color: #63b0a8;
  padding-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const TopicContent = styled.div`
  font-size: 15px;
  font-weight: 500;
  margin: 10px 0 10px;
  color: hsl(0deg, 0%, 0%, 80%);
  max-height: 98px;
  overflow: hidden;
  letter-spacing: 0.58px;
  line-height: 1.56;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  @media (max-width: 720px) {
    font-size: 16px;
  }
  span {
    font-family: 'Montserrat' !important;
    font-size: 13px !important;
  }

  div {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const TopicType = styled.ul`
  display: flex;
  padding: 10px 0;
  border-bottom: 2px solid hsl(0deg, 0%, 0%, 10%);

  li {
    font-size: 14px;
    color: hsl(0deg, 0%, 0%, 87%);
    flex-basis: 20%;
    text-align: center;
    position: relative;
    cursor: pointer;
    margin-right: 10px;
    transition: all 0.3s ease;

    &.active {
      font-weight: 500;
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        bottom: -12px;
        height: 3px;
        background-color: hsl(0deg, 0%, 0%, 80%);
        left: 0;
      }
    }

    &:hover {
      font-weight: 500;
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        bottom: -12px;
        height: 3px;
        background-color: #000;
        left: 0;
      }
    }
  }
`;

export const RelatedCardTopHeading = styled.div`
  padding: 16px 10px 10px;

  h4 {
    font-size: clamp(16px, 2vw, 18px);
    color: hsl(0deg, 0%, 0%, 87%);
    padding-bottom: 5px;
  }

  h6 {
    font-size: clamp(12px, 2vw, 15px);
    color: hsl(0deg, 0%, 0%, 60%);
    font-weight: 500;
  }
`;
